var _path, _g, _g2, _g3, _g4, _rect, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4, _rect5, _circle5, _rect6, _circle6, _rect7, _circle7, _rect8, _circle8, _rect9, _circle9, _rect0, _circle0, _rect1, _circle1, _rect10, _circle10, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 35,
    viewBox: "0 0 144 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6377 2.18066C20.2428 2.18076 23.7343 4.53412 25.2217 5.92285C25.5779 6.25542 25.7349 6.40218 25.9141 6.81445C26.0916 7.22308 26.0937 7.5304 26.0938 8.22461V21.4609C26.0938 22.266 26.0912 22.6274 25.9727 22.9678C25.854 23.3082 25.6412 23.5804 25.1621 24.1846C22.1358 28.0009 19.6801 30.1943 15.6934 32.6035C14.6574 33.2295 14.1928 33.5036 13.6211 33.5146C13.0494 33.5256 12.5779 33.2713 11.5254 32.6895C7.38083 30.3983 4.90183 28.2054 1.97754 24.1279C1.56901 23.5583 1.38748 23.3026 1.28516 22.9844C1.18293 22.6664 1.18066 22.3344 1.18066 21.5947V8.22461C1.18066 7.5304 1.18283 7.22308 1.36035 6.81445C1.53951 6.40213 1.69654 6.25543 2.05273 5.92285C3.54011 4.53411 7.03215 2.18066 13.6377 2.18066Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.361853
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_990_9193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08667 11.1414C4.08667 10.1899 4.08667 9.7141 4.44268 9.00549C4.79868 8.29688 5.03346 8.1222 5.50302 7.77285C6.92618 6.71399 9.53525 5.4328 13.8286 5.4328C18.1219 5.4328 20.731 6.71399 22.1541 7.77285C22.6237 8.1222 22.8585 8.29688 23.2145 9.00549C23.5705 9.7141 23.5705 10.1899 23.5705 11.1414V19.4045C23.5705 20.5473 23.5705 21.1188 23.3709 21.6703C23.1714 22.2219 22.8387 22.6213 22.1735 23.4202C20.4665 25.4701 18.9204 26.8898 16.8501 28.2777C15.4746 29.1998 14.7868 29.6609 13.7976 29.6761C12.8084 29.6914 12.1188 29.2593 10.7397 28.3952C8.55842 27.0285 6.9818 25.5673 5.28634 23.332C4.71925 22.5844 4.43571 22.2105 4.26119 21.6917C4.08667 21.1728 4.08667 20.6468 4.08667 19.5949V11.1414Z",
    fill: "#55E6C1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_990_9193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90332 10.9284C5.90332 10.4928 5.90332 10.275 6.03097 9.9945C6.15863 9.71395 6.2768 9.61099 6.51314 9.40505C7.48051 8.56214 9.69507 7.1828 13.8289 7.1828C17.9628 7.1828 20.1774 8.56214 21.1448 9.40505C21.3811 9.61099 21.4993 9.71395 21.6269 9.9945C21.7546 10.275 21.7546 10.4928 21.7546 10.9284V19.4771C21.7546 20.126 21.7546 20.4504 21.6478 20.7573C21.5411 21.0643 21.3481 21.3081 20.9621 21.7958C19.1252 24.1167 17.5862 25.6334 15.1233 27.1626C14.5159 27.5397 14.2121 27.7282 13.8216 27.7358C13.4311 27.7433 13.1223 27.5678 12.5046 27.2166C9.93244 25.7543 8.3711 24.2302 6.5819 21.7429C6.25316 21.2859 6.08879 21.0574 5.99605 20.7697C5.90332 20.482 5.90332 20.1835 5.90332 19.5865L5.90332 10.9284Z",
    fill: "#4846BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_990_9193)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.8799,
    cy: 8.06224,
    r: 2.53569,
    fill: "#4846BC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_990_9193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62402 17.3026L12.424 20.108L17.9073 14.614",
    stroke: "#D4D1F7",
    strokeWidth: 2.36664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.366586,
    y: 6.06547,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.36163,
    cy: 7.06057,
    r: 0.54278,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9728,
    y: 6.06547,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9678,
    cy: 7.06057,
    r: 0.54278,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.366586,
    y: 21.9905,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.36163,
    cy: 22.9856,
    r: 0.54278,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3843,
    y: 2.77152,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9648,
    cy: 3.35199,
    r: 0.316622,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54838,
    y: 2.77152,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.12888,
    cy: 3.35199,
    r: 0.316622,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3843,
    y: 28.2778,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9648,
    cy: 28.8582,
    r: 0.316622,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54838,
    y: 28.2778,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.12888,
    cy: 28.8582,
    r: 0.316622,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9728,
    y: 21.9905,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9678,
    cy: 22.9856,
    r: 0.54278,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6698,
    y: 32.478,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6649,
    cy: 33.4731,
    r: 0.54278,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6698,
    y: 1.00297,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6649,
    cy: 1.99807,
    r: 0.54278,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.663366,
    y: 14.4403,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.24387,
    cy: 15.0208,
    r: 0.316622,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.45,
    y: 14.4403,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0305,
    cy: 15.0208,
    r: 0.316622,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9151 29.0508L82.3029 28.33L81.4604 26.594H81.9469L82.5267 27.8806L83.1136 26.594H83.6035L82.391 29.0508H81.9151Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6347 28.3508H79.1711L79.1764 25.894H79.6347V26.7435C79.8338 26.6272 80.0946 26.5602 80.3326 26.5602H80.426C80.7908 26.5602 81.0922 26.7188 81.2614 26.9938C81.4323 27.2687 81.4305 27.6882 81.2614 27.9578C81.0922 28.2328 80.7908 28.3914 80.426 28.3914H80.3326C80.0946 28.3914 79.8338 28.3244 79.6347 28.2081V28.3508ZM79.6347 27.5595C79.6717 27.8521 79.9078 28.0354 80.3026 28.0354C80.6903 28.0354 80.9194 27.8221 80.9194 27.4749C80.9194 27.1295 80.6903 26.9162 80.3026 26.9162C79.9078 26.9162 79.6717 27.0995 79.6347 27.3903V27.5595Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9937 25.4462C86.4234 25.4221 86.9583 25.5361 87.3645 25.6785C87.3626 25.9069 87.3607 26.1353 87.3588 26.3643C87.1612 26.3941 87.1568 26.307 87.0377 26.2394C86.675 26.0355 86.1564 25.8956 85.753 26.0582C85.4023 26.1997 85.3703 26.6258 85.5923 26.7497C86.0334 26.9952 87.3568 26.8065 87.4908 27.7869C87.543 28.1681 87.453 28.4628 87.1525 28.7106C86.5181 29.2337 85.5014 29.0776 84.8066 28.7503C84.8086 28.5181 84.8105 28.2859 84.8124 28.0532C85.0401 28.0182 85.0741 28.1303 85.2368 28.223C85.5971 28.4287 86.0621 28.6023 86.4755 28.4495C86.731 28.3554 86.9482 28.0527 86.8253 27.8091C86.6674 27.4965 85.699 27.5079 85.3741 27.3613C84.4435 26.9417 84.688 25.5205 85.9937 25.4462Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0013 25.4462C88.2138 25.4481 88.4257 25.45 88.6382 25.4519C88.6401 25.8922 88.642 26.3321 88.6439 26.7724H90.0664C90.0683 26.3321 90.0702 25.8922 90.0721 25.4519H90.7032C90.7013 26.6513 90.6994 27.8508 90.6975 29.0502C90.4889 29.0483 90.2807 29.0464 90.0721 29.0445C90.0702 28.4836 90.0683 27.9227 90.0664 27.3617H88.6439C88.642 27.9227 88.6401 28.4836 88.6382 29.0445H87.9956C87.9975 27.8451 87.9994 26.6457 88.0013 25.4462Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3046 25.7976V26.3983C94.3075 26.4447 94.1247 26.4399 94.0922 26.4324C94.0367 26.4191 93.6998 26.0308 93.0596 25.9901C91.6324 25.9003 91.563 27.6895 92.2453 28.2566C92.6266 28.5739 93.2194 28.5153 93.662 28.3644V27.7183C93.3735 27.7164 93.0845 27.7146 92.796 27.7127V27.1234C93.2989 27.1271 93.8017 27.1309 94.3046 27.1347V28.6874C94.2668 28.7721 93.9807 28.8724 93.8745 28.9026C93.4788 29.0166 92.6209 29.1017 92.2343 28.9934C91.3683 28.7508 91.053 27.5292 91.2305 26.7549C91.496 25.5985 92.6199 25.2637 93.6912 25.5252C93.8142 25.555 94.2606 25.7016 94.3051 25.7972L94.3046 25.7976Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6719 23.1371C34.0907 23.1371 33.5473 23.0268 33.0419 22.8064C32.5365 22.5859 32.0917 22.2814 31.7076 21.893C31.3286 21.4993 31.0304 21.0399 30.813 20.515C30.6008 19.9848 30.4946 19.4126 30.4946 18.7984C30.4946 18.179 30.6033 17.6094 30.8206 17.0897C31.0379 16.5648 31.3361 16.1107 31.7152 15.7275C32.0943 15.3391 32.5314 15.0399 33.0268 14.8299C33.5271 14.6147 34.0578 14.507 34.6188 14.507C35.0838 14.507 35.5361 14.5805 35.9758 14.7275C36.4156 14.8692 36.8022 15.0635 37.1358 15.3102L36.4686 16.8378C36.3221 16.696 36.1502 16.5753 35.9531 16.4756C35.756 16.3758 35.5462 16.2997 35.3239 16.2472C35.1015 16.1895 34.8816 16.1606 34.6643 16.1606C34.1993 16.1606 33.7849 16.2735 33.421 16.4992C33.0621 16.7249 32.7766 17.0399 32.5643 17.4441C32.3571 17.843 32.2535 18.2997 32.2535 18.8142C32.2535 19.3181 32.3571 19.7722 32.5643 20.1764C32.7715 20.5806 33.0571 20.9008 33.421 21.137C33.7849 21.368 34.2018 21.4835 34.6719 21.4835C35.0459 21.4835 35.3971 21.4179 35.7257 21.2867C36.0592 21.1502 36.317 20.9927 36.499 20.8142L37.1585 22.3654C36.8654 22.5806 36.504 22.7644 36.0744 22.9166C35.6448 23.0636 35.1773 23.1371 34.6719 23.1371Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7906 23.1686C41.0224 23.1686 40.3325 22.9848 39.721 22.6174C39.1094 22.2447 38.6242 21.7329 38.2654 21.0819C37.9065 20.4257 37.7271 19.6698 37.7271 18.8142C37.7271 17.9638 37.9065 17.2157 38.2654 16.5701C38.6242 15.9244 39.1094 15.4204 39.721 15.0582C40.3325 14.696 41.0224 14.5149 41.7906 14.5149C42.569 14.5149 43.2639 14.696 43.8755 15.0582C44.487 15.4204 44.9697 15.9244 45.3235 16.5701C45.6773 17.2157 45.8542 17.9638 45.8542 18.8142C45.8542 19.6698 45.6748 20.4257 45.3159 21.0819C44.9621 21.7329 44.4769 22.2447 43.8603 22.6174C43.2488 22.9848 42.5589 23.1686 41.7906 23.1686ZM41.7906 21.5229C42.2354 21.5229 42.6322 21.41 42.9809 21.1843C43.3296 20.9586 43.6026 20.6436 43.7997 20.2394C44.0018 19.8299 44.1029 19.3549 44.1029 18.8142C44.1029 18.284 44.0044 17.8194 43.8072 17.4205C43.6101 17.0215 43.3372 16.7118 42.9885 16.4913C42.6448 16.2708 42.248 16.1606 41.7982 16.1606C41.3535 16.1606 40.9567 16.2708 40.608 16.4913C40.2592 16.7118 39.9838 17.0215 39.7816 17.4205C39.5845 17.8194 39.486 18.284 39.486 18.8142C39.486 19.3549 39.5845 19.8299 39.7816 20.2394C39.9838 20.6436 40.2567 20.9586 40.6004 21.1843C40.9491 21.41 41.3459 21.5229 41.7906 21.5229Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.287 23.0426V14.6409H49.0231V15.6724H49.3036L48.6516 16.4913C48.8791 15.8614 49.2177 15.3758 49.6675 15.0346C50.1173 14.6881 50.6455 14.5149 51.252 14.5149C51.8181 14.5149 52.2957 14.6645 52.6848 14.9637C53.0791 15.2577 53.357 15.654 53.5188 16.1527L53.0412 15.696H53.6931L53.1094 16.1527C53.3621 15.6015 53.7336 15.1921 54.2238 14.9244C54.7141 14.6514 55.2473 14.5149 55.8235 14.5149C56.3137 14.5149 56.7307 14.6015 57.0744 14.7748C57.4231 14.948 57.7036 15.1816 57.9159 15.4756C58.1332 15.7695 58.2924 16.1029 58.3935 16.4756C58.4996 16.843 58.5527 17.2236 58.5527 17.6173V23.0426H56.756V17.9087C56.756 17.326 56.6296 16.885 56.3769 16.5858C56.1242 16.2813 55.7805 16.1291 55.3459 16.1291C55.0679 16.1291 54.8126 16.1947 54.5802 16.326C54.3477 16.4572 54.1607 16.654 54.0191 16.9165C53.8827 17.179 53.8144 17.5097 53.8144 17.9087V23.0426H52.0253V17.9087C52.0253 17.326 51.8964 16.885 51.6386 16.5858C51.3859 16.2813 51.0423 16.1291 50.6076 16.1291C50.1881 16.1291 49.8267 16.2813 49.5235 16.5858C49.2253 16.8903 49.0762 17.3443 49.0762 17.948V23.0426H47.287Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.357 26.3497V14.6409H62.0931V15.6173H62.3282L61.9339 16.4519V21.0977L62.4419 22.0583H62.1462V26.3497H60.357ZM64.5949 23.1686C63.9177 23.1686 63.3112 22.977 62.7754 22.5938C62.2448 22.2105 61.8253 21.6882 61.517 21.0268C61.2087 20.3654 61.052 19.6226 61.0469 18.7984C61.052 17.9743 61.2036 17.2394 61.5018 16.5937C61.8051 15.9428 62.2195 15.4309 62.7451 15.0582C63.2758 14.6855 63.8823 14.4992 64.5646 14.4992C65.1964 14.4992 65.7902 14.6698 66.3462 15.011C66.9022 15.3522 67.3494 15.8456 67.6881 16.4913C68.0318 17.137 68.1985 17.9218 68.1884 18.8457C68.1935 19.5333 68.0975 20.1475 67.9003 20.6882C67.7032 21.2237 67.4354 21.6751 67.0967 22.0426C66.7581 22.41 66.3715 22.6909 65.9368 22.8851C65.5072 23.0741 65.0599 23.1686 64.5949 23.1686ZM64.2235 21.5622C64.648 21.5622 65.0271 21.4441 65.3606 21.2079C65.6942 20.9717 65.952 20.6488 66.1339 20.2394C66.3209 19.8247 66.4119 19.3522 66.4068 18.8221C66.4119 18.2761 66.3209 17.801 66.1339 17.3968C65.9469 16.9874 65.6841 16.6698 65.3455 16.4441C65.0119 16.2183 64.6303 16.1081 64.2007 16.1134C63.7964 16.1081 63.43 16.2157 63.1014 16.4362C62.778 16.6514 62.5177 16.9611 62.3206 17.3653C62.1285 17.7695 62.0325 18.2551 62.0325 18.8221C62.0325 19.3522 62.126 19.8247 62.313 20.2394C62.5051 20.6488 62.7653 20.9717 63.0939 21.2079C63.4224 21.4441 63.7989 21.5622 64.2235 21.5622Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.509 23.1686C71.0845 23.1686 70.7332 23.0741 70.4552 22.8851C70.1823 22.6961 69.9776 22.4336 69.8411 22.0977C69.7047 21.7617 69.6364 21.3733 69.6364 20.9323V10.9164H71.4256V20.7827C71.4256 20.9034 71.4383 21.0216 71.4635 21.137C71.4888 21.2525 71.5393 21.3496 71.6151 21.4284C71.696 21.5019 71.8224 21.5386 71.9942 21.5386C72.065 21.5386 72.1281 21.5334 72.1837 21.5229C72.2444 21.5071 72.2975 21.4914 72.3429 21.4756V23.0268C72.2368 23.0741 72.1079 23.1082 71.9563 23.1292C71.8097 23.1554 71.6606 23.1686 71.509 23.1686Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7682 23.0426V14.6409H75.5574V23.0426H73.7682ZM74.6628 13.4677C74.3242 13.4677 74.0386 13.3469 73.8061 13.1054C73.5787 12.864 73.465 12.57 73.465 12.2235C73.465 11.8771 73.5787 11.5831 73.8061 11.3416C74.0386 11.1002 74.3242 10.9794 74.6628 10.9794C74.9964 10.9794 75.2794 11.1002 75.5119 11.3416C75.7444 11.5831 75.8606 11.8771 75.8606 12.2235C75.8606 12.57 75.7444 12.864 75.5119 13.1054C75.2794 13.3469 74.9964 13.4677 74.6628 13.4677Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1555 22.841L81.3631 11.5527H83.071L87.2476 22.841H85.4621L82.9779 16.0358C82.9468 15.9605 82.8847 15.7777 82.7916 15.4875C82.7088 15.1972 82.6104 14.8747 82.4966 14.5199C82.3827 14.1651 82.2792 13.8426 82.186 13.5523C82.0929 13.2513 82.0308 13.0578 81.9997 12.9718L82.3568 12.9556C82.2947 13.1384 82.2171 13.3696 82.1239 13.6491C82.0411 13.9286 81.948 14.2242 81.8444 14.536C81.7513 14.8478 81.6581 15.1434 81.565 15.423C81.4718 15.6917 81.3942 15.9175 81.3321 16.1003L78.8634 22.841H77.1555ZM79.0187 20.035L79.6397 18.3579H84.5771L85.2913 20.035H79.0187Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7567 22.841V21.2284H90.5112V13.1653H88.7567V11.5527H93.9425V13.1653H92.188V21.2284H93.9425V22.841H88.7567Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_990_9193",
    x: 0.909034,
    y: 4.26209,
    width: 23.8322,
    height: 28.5921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.00346,
    dy: 1.00346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08709
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_990_9193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_990_9193",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.501732,
    dy: -0.501732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.309401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_990_9193"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_990_9193",
    x: 5.40159,
    y: 7.1828,
    width: 16.3531,
    height: 21.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.501732,
    dy: 0.501732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.878031
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_990_9193"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_990_9193",
    x: 18.9216,
    y: 4.75317,
    width: 6.76175,
    height: 7.53523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.422615,
    dy: 0.84523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.422615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_990_9193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_990_9193",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.773385,
    dy: -0.773385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.422615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_990_9193"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_990_9193",
    x: 5.80356,
    y: 12.0615,
    width: 15.248,
    height: 12.4587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.338092,
    dy: 0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0272251 0 0 0 0 0.0125 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_990_9193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_990_9193",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.338092,
    dy: 0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.308509
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_990_9193"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.338092,
    dy: -0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.393032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_990_9193",
    result: "effect3_innerShadow_990_9193"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.505f2090e1696b9d165cee966c5439b6.svg";
export { ForwardRef as ReactComponent };